import React, { useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({ mayor, handleCancelClick, increment, setMayorId }) => {
  const [mayor1, setMayor1] = useState(mayor);
  const axiosPrivate = useAxiosPrivate();
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    if (name === "active") {
      mayor1.active = e.target.checked;
    } else
      setMayor1((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "mayor/" + mayor1.id + "/",
          mayor1,
          {
            signal: controller.signal,
          }
        );
        //isMounted && setDocuments(response.data);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    updateData();
    setMayorId(null);
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          name="full_name"
          className="form-control"
          id="full_name"
          value={mayor1.full_name}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="full_name_arb"
          className="form-control"
          id="full_name_arb"
          value={mayor1.full_name_arb}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="date"
          name="start_date"
          className="form-control"
          id="start_date"
          value={mayor1.start_date}
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="date"
          name="end_date"
          className="form-control"
          id="end_date"
          value={mayor1.end_date}
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="checkbox"
          id="active"
          name="active"
          defaultChecked={mayor1.active}
          value={mayor1.active}
          onChange={handleChange}
          disabled
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
